const format = (date, locale = null, format = null, replaceValue = '-') => {
    return new Intl.DateTimeFormat(locale ?? 'fr-FR', {
        timeZone: 'Europe/Paris',
        ...(format ? format : {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric'
        })
    }).format(date).replace(/\//g, replaceValue);
}

const isSameDate = (dateStr1, dateStr2) => {
    const date1 = new Date(dateStr1);
    const date2 = new Date(dateStr2);

    return date1.getFullYear() === date2.getFullYear() &&
        date1.getMonth() === date2.getMonth() &&
        date1.getDate() === date2.getDate();
}

const isSameDateAndTime = (dateStr1, dateStr2) => {
    const date1 = new Date(dateStr1);
    const date2 = new Date(dateStr2);

    return date1.getFullYear() === date2.getFullYear() &&
        date1.getMonth() === date2.getMonth() &&
        date1.getDate() === date2.getDate() &&
        date1.getHours() === date2.getHours() &&
        date1.getMinutes() === date2.getMinutes();
}

const isValidDate = (date) => {
    return date && Object.prototype.toString.call(date) === "[object Date]" && !isNaN(date);
}

const getGivenWeekStart = (date = new Date()) => {
    const day = date.getDay();
    const diff = (day === 0 ? -6 : 1) - day;

    const start = new Date(date);
    start.setDate(date.getDate() + diff);
    start.setHours(0, 0, 0, 0); // Set to start of the day (00:00:00.000)

    return start;
};
const getGivenWeekEnd = (date = new Date()) => {
    const start = getGivenWeekStart(date)
    const end = new Date(start);
    end.setDate(start.getDate() + 6);
    end.setHours(23, 59, 59, 999);
    return end;
};

const getOffsetDate = (dayOffset, baseDate = new Date()) => {
        const newDate = new Date(baseDate);
        newDate.setDate(newDate.getDate() + (dayOffset));
        return newDate;
    };

export default {
    format,
    isSameDate,
    isValidDate,
    isSameDateAndTime,
    getOffsetDate,
    getGivenWeekEnd,
    getGivenWeekStart,
};

